import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AttributionCampaignComponent } from './containers/attribution-campaign.component';

const routes: Routes = [
  {
    path: '',
    component: AttributionCampaignComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AttributionCampaignRoutingModule {
}
